<div class="page">
  <!-- Header -->
  <div class="page-header">
    <div class="page-header__inner">
      <div class="page-header__text">
        <h1>My Applications</h1>
        <p>Track and manage your job applications</p>
      </div>
      <div class="page-header__search">
        <nz-input-group [nzSuffix]="suffixIconSearch">
          <input
            type="text"
            nz-input
            placeholder="Search by title or status..."
            [(ngModel)]="searchKeyword"
            (ngModelChange)="this.searchText.next($event)"
          />
        </nz-input-group>
        <ng-template #suffixIconSearch>
          <i nz-icon nzType="search"></i>
        </ng-template>
      </div>
    </div>
  </div>

  <!-- Content -->
  <div class="page-content">
    @if (allApplications.length !== 0) {
      <!-- Cards -->
      <div class="cards">
        @for (application of paginatedData; track application.jobRequestId) {
          <div
            class="card"
            [class.card--closed]="application.status.toUpperCase() === 'DELETED' || application.status.toUpperCase().includes('CLOSED')"
          >
            <div class="card__main">
              <!-- Left: Icon + Info -->
              <div class="card__left">
                <div class="card__icon">
                  <i class="jobs-icon" [ngClass]="getCategoryIcon(application.category)"></i>
                </div>
                <div class="card__info">
                  <div class="card__title-row">
                    @if (application.status.toUpperCase() !== 'DELETED') {
                      <a class="card__title" [routerLink]="'/job-preview/' + application.jobRequestId">
                        {{ application.postingTitle }}
                      </a>
                    } @else {
                      <a class="card__title card__title--closed" (click)="clickJr()">
                        {{ application.postingTitle }}
                      </a>
                    }
                    <span class="card__chip card__chip--id">JR-{{ application.jobRequestId }}</span>
                  </div>
                  <div class="card__meta">
                    @if (application.category) {
                      <span class="card__chip card__chip--category">
                        <i class="fa-regular fa-layer-group"></i>
                        {{ application.category }}
                      </span>
                    }
                    <span class="card__chip">
                      <i class="fa-regular fa-location-dot"></i>
                      <span [innerHTML]="formatLocation(application.workLocation)"></span>
                    </span>
                    <span class="card__chip card__chip--date">
                      <i class="fa-regular fa-calendar"></i>
                      {{ application.date | date : 'dd MMM yyyy' }}
                    </span>
                  </div>
                </div>
              </div>

              <!-- Right: Badge + Actions -->
              <div class="card__right">
                <span
                  class="card__badge"
                  [style.backgroundColor]="getStatusStyle(application.labelChange).bg"
                  [style.color]="getStatusStyle(application.labelChange).text"
                >
                  <i class="fa-regular" [ngClass]="getStatusIcon(application.labelChange)"></i>
                  {{ application.labelChange }}
                </span>
                @if (application.status.toUpperCase() !== 'DELETED' && !application.status.toUpperCase().includes('CLOSED')) {
                  <a nz-dropdown nzTrigger="click" [nzDropdownMenu]="menu" class="card__more" role="button" aria-label="Actions">
                    <i class="fa-solid fa-ellipsis-vertical"></i>
                  </a>
                  <nz-dropdown-menu #menu="nzDropdownMenu">
                    <ul nz-menu>
                      <a nz-menu-item [routerLink]="'/job-preview/' + application.jobRequestId" target="_blank">
                        <i class="fa-regular fa-arrow-up-right-from-square" style="color: var(--color-brand)"></i>
                        &nbsp;&nbsp;View in new tab
                      </a>
                      @if (!application.isWithdrawHidden) {
                        <li nz-menu-item (click)="cancelJrApplication(application)">
                          <i class="fa-regular fa-trash" style="color: var(--color-utility-danger)"></i>
                          &nbsp;&nbsp;&nbsp;Withdraw
                        </li>
                      }
                    </ul>
                  </nz-dropdown-menu>
                }
              </div>
            </div>
          </div>
        }
      </div>

      <!-- Bottom Pagination -->
      @if (paginatedData.length !== 0) {
        <div class="pagination-bar">
          <nz-pagination
            nzShowSizeChanger
            [nzPageIndex]="currentPage"
            [nzTotal]="totalRows"
            [nzPageSize]="itemsPerPage"
            [nzPageSizeOptions]="pageSizeOption"
            (nzPageIndexChange)="pageIndexChanged($event)"
            (nzPageSizeChange)="pageSizeChanged($event)"
          />
        </div>
      }

      <!-- No search results -->
      @if (paginatedData.length === 0) {
        <div class="empty-state">
          <img src="../../assets/images/no-results-application.svg" alt="" />
          <h2>No matching applications</h2>
          <p>Try adjusting your search keywords</p>
        </div>
      }
    }

    <!-- No applications at all -->
    @if (allApplications.length === 0) {
      <div class="empty-state">
        <img src="../../assets/images/no-results-application.svg" alt="" />
        <h2>No applications yet</h2>
        <p>Your job applications will appear here once you apply</p>
      </div>
    }
  </div>
</div>
